export const SET_CAR_CONTRACT = "SET_CAR_CONTRACT";
export const SET_SIGNER = "SET_SIGNER";
export const SET_IS_OWNER = "SET_IS_OWNER";